import axios from "axios";
import { getHeaders } from '../helpers';
import { getChestApiUrl } from '../../helpers';

/**
 * Get all info for payment flight or hotel
 *
 * @param {String} params.lang          Language
 * @param {String} params.token         Booking's token
 * @param {String} params.insurance     Insurance
 */
const getInfoPayment = params => {
	let url = `${getChestApiUrl()}/chestApi/payment/${params.lang}/${params.token}`

	if (params.insurance) url += `?insurance=${params.insurance}`

	return axios.get(url, { headers: getHeaders() })
}

const getPaymentCardForm = params =>  axios.get(`${getChestApiUrl()}/chestApi/payment-card/${params.lang}/${params.token}`, { headers: getHeaders() })

/**
 * Post paypal payment ok
 *
 * @param {Object} data
 * @param {String} data.token  payment token
 * @param {String} data.nonce  paypal nonce
 */
const postPaypal = data => axios({
	method: 'post',
	url: `${getChestApiUrl()}/chestApi/payment/response/paypal`,
	headers: getHeaders(),
	data
})

const postPaymentCardForm = data => axios.post(`${getChestApiUrl()}/chestApi/payment-card/${data.language}/${data.token}`, data, { headers: getHeaders() })


export default {
	getInfoPayment,
	postPaypal,
	getPaymentCardForm,
	postPaymentCardForm
}
